import React from 'react'

import ChallengePage from './ChallengePage'
import NewUserPage from './NewUserPage'
import ProfilePage from './ProfilePage'
import {
  AdminDashboard,
  // AdminNewUser,
  AdminProfessors,
  AdminStudents,
} from '../components'

import { InternalContent } from './styles'

const AdministrationPage = ({ part }: { part: string }) => {
  // const [showCourseForm, setShowCourseForm] = useState(false)

  return (
    <InternalContent>
      {part === 'dashboard' && (
        <AdminDashboard
        // showCourseForm={showCourseForm}
        // setShowCourseForm={setShowCourseForm}
        />
      )}
      {part === 'admin-students' && <AdminStudents />}
      {part === 'admin-professors' && <AdminProfessors />}
      {/* TODO Reemplazar en AdminNewUser por ProfileView*/}
      {/* {part === 'admin-new-user' && <AdminNewUser />} */}
      {part === 'admin-new-user' && <NewUserPage />}

      {part === 'admin-profile' && <ProfilePage />}
      {part === 'admin-challenge' && <ChallengePage />}
      {/* <Outlet /> */}
      {/* {location.pathname === '/' && (
        <Admin
          showCourseForm={showCourseForm}
          setShowCourseForm={setShowCourseForm}
        />
      )} */}
    </InternalContent>
  )
}

export default AdministrationPage
